<template>
  <linkable-item
    :class="['notification-item', { unread: !notification.read }]"
    as="router-link"
    hide-router-link-active
    :to="link"
    :data-id="notification.id"
    @click.native="markAsRead"
  >
    <align direction="flex-start">
      <div>
        <card-image
          v-if="notification.card && notification.card.image"
          :image-url="notification.card.image"
        />

        <div v-else class="icon-wrapper">
          <icon :name="notificationIcon" />
        </div>
      </div>

      <div class="text">
        {{ notification.title }}
      </div>
    </align>
  </linkable-item>
</template>

<script>
import { mapState } from 'vuex';
import * as Sentry from '@sentry/vue';

import { notificationService } from '@/services';

import CardImage from '@cardladder/shared/components/CardImage';

export default {
  components: {
    CardImage,
  },

  props: {
    notification: Object,
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),

    showEmptyState() {
      return !this.loading && this.loaded && this.dateFilter === null && this.sales.length === 0;
    },

    link() {
      const type = this.notification.type;

      let url = this.notification.page ? this.notification.page.toLowerCase() : '';

      if (type === 'WATCHLIST_PRICE_DECREASE' || type === 'WATCHLIST_PRICE_INCREASE') {
        url = `/watchlist?cardId=${this.notification.card.id}`;
      } else if (this.notification.data?.collectionId) {
        url = `/collection?id=${this.notification.data.collectionId}`;
      }

      return url;
    },

    notificationIcon() {
      let icon = 'subject';

      if (this.notification.icon) {
        icon = this.notification.icon.replace(/-/g, '_');
      }

      return icon;
    },
  },

  methods: {
    async markAsRead() {
      try {
        await notificationService.markNotificationAsRead(this.user.uid, this.notification.id);
        this.$emit('read', this.notification.id);
      } catch (e) {
        this.$toasted.error('Error marking the notification');
        Sentry.captureException(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.notification-item {
  display: flex;
  padding: $gp;
  border-bottom: 1px solid var(--theme-border);

  &.unread .text {
    font-weight: bold;
  }
}

.card-image {
  --card-image-width: 42px;
}

.text {
  font-size: 14px;
}
</style>
